import type { IntegrationDescription } from "@smartsuite/automation-engine-api";
import { makeAutoObservable } from "mobx";

export class IntegrationStore {
  list: IntegrationDescription[] = [];
  pageSize: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setList(integrationList: IntegrationDescription[]): void {
    this.list = integrationList;
  }
}
